import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/9works_Logo/svg/9works_Original_White.svg';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <img src={logo} alt="9works" />
            <p>
              Intelligent workforce management platform that automates scheduling,
              tracks attendance, and streamlines operations for modern teams.
            </p>
          </div>
          <div>
            <div className="footer-title">Product</div>
            <ul className="footer-links">
              <li><a href="#features">Features</a></li>
              <li><a href="#modules">Modules</a></li>
              <li><a href="#how-it-works">How It Works</a></li>
              <li><a href="#why-9works">Why 9works</a></li>
            </ul>
          </div>
          <div>
            <div className="footer-title">Company</div>
            <ul className="footer-links">
              <li><a href="https://www.ninea.ai" target="_blank" rel="noopener noreferrer">ninea.ai</a></li>
              <li><a href="https://www.glidenine.com" target="_blank" rel="noopener noreferrer">GLIDENINE</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          <div>
            <div className="footer-title">Legal</div>
            <ul className="footer-links">
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service">Terms of Service</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {year} 9works. A product by <a href="https://www.ninea.ai" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--green-primary)', textDecoration: 'none' }}>ninea.ai</a>. All rights reserved.</p>
          <div className="footer-socials">
            <a href="https://www.linkedin.com/company/9-works" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
